import { FileTrigger } from "react-aria-components";

import type { FileUploadTriggerProps } from "../types";

// See FileUploadDropZone: the barrel would pull the PDF viewer in with it.
import { useFileUploaderContext } from "../UseFileUploaderContext";

export function FileUploadTrigger({ children }: FileUploadTriggerProps) {
  const { acceptedFileTypes, addFiles, allowsMultiple } =
    useFileUploaderContext();

  return (
    <FileTrigger
      acceptedFileTypes={acceptedFileTypes}
      allowsMultiple={allowsMultiple}
      onSelect={addFiles}
    >
      {children}
    </FileTrigger>
  );
}
